var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Share",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)",
    stroke: "#535455",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57475,9.7129 C6.91825,8.4019 5.56575,7.4999 4.00025,7.4999 C1.79125,7.4999 0.00025,9.2909 0.00025,11.4999 C0.00025,13.7094 1.79125,15.4999 4.00025,15.4999 C5.56575,15.4999 6.91825,14.5984 7.57475,13.2869",
    id: "Stroke-1149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,8 C21.209,8 23,6.2095 23,4 C23,1.791 21.209,0 19,0 C16.791,0 15,1.791 15,4 C15,4.643 15.156,5.249 15.425,5.787",
    id: "Stroke-1150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42485,17.2129 C14.09835,19.8619 16.02285,22.9999 18.99985,22.9999 C21.20885,22.9999 22.99985,21.2094 22.99985,18.9999 C22.99985,16.7909 21.20885,14.9999 18.99985,14.9999",
    id: "Stroke-1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,8 C17.434,8 16.082,7.098 15.425,5.787 L7.5745,9.713 C7.844,10.251 8,10.857 8,11.5 C8,12.143 7.844,12.749 7.5745,13.287 L15.425,17.213 C16.082,15.902 17.434,15 19,15",
    id: "Stroke-1152"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.5633897a.svg";
export { ForwardRef as ReactComponent };